import { Component, forwardRef, Input, OnInit } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { map } from 'rxjs/operators';
import { Vehicle } from 'src/app/vehicles/model/vehicle';
import { VehiclesService } from 'src/app/vehicles/service/vehicles.service';

@Component({
  selector: 'app-stp-vehicle-selector',
  templateUrl: './stp-vehicle-selector.component.html',
  styleUrls: ['./stp-vehicle-selector.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => StpVehicleSelectorComponent),
      multi: true
    }
  ]
})
export class StpVehicleSelectorComponent implements OnInit {
  @Input() type: 'id' | 'sideNumber' = 'id';

  availableVehicles: AvaliableVehicle[] = [];
  value: string | number | null = null;
  disabled: boolean = false;

  onChange: any = () => { };
  onTouched: any = () => { };

  constructor(private vehicleService: VehiclesService) { }


  ngOnInit(): void {
    this.vehicleService.getVehicles()
      .pipe(
        map(vehs => vehs.map(v => new AvaliableVehicle(v.sideNumber, this.getOptionValue(v))))
      )
      .subscribe(s => {
        this.availableVehicles = s;
      });
  }


  getOptionValue(item: Vehicle): any {
    return this.type ? item[this.type] : item;
  }

  writeValue(value: string | number | null): void {
    this.value = value;
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  onSelectChange(value: string | number | null): void {
    this.value = value;
    this.onChange(value);
  }

}

class AvaliableVehicle {
  constructor(
    public readonly displayValue: string,
    public readonly value: number | string,
  ) { }
}
